export default ({ axios, mapQueryString }) => ({
    index: (query = {}) => axios.get(`/clients${mapQueryString(query)}`)
})


// WEBPACK FOOTER //
// ./src/api/clients.js